<template>
  <div :class="[classes]">
    <div v-if="is_blue_bg" class="absolute right-0 top-0 w-full h-full bg-[#2DA7D7] z-20 opacity-40" />
    <div v-if="is_blue_bg" class="absolute inset-1/4 w-[40%] h-[30%] rounded-3xl z-20 bg-gradient-to-r from-[#2da8d7] to-[#467ddf]">
      <Gem class="absolute -z-10 bottom-2 right-5 w-48 h-48 text-dark-brand-blue opacity-10" />
      <div class="flex flex-col w-full h-full px-16 py-12">
        <Gem class="border-none -ml-2 w-16 h-16 dark:text-gray-500" />
        <span class="text-white">{{ $t("You reached the Dashboard limits on your free plan.") }}</span>
        <span class="text-white">{{ $t("Want") }} <span class="font-semibold">{{ $t("unlimited pages?") }}</span>
        </span>
        <button class="font-normal btn cancel-btn ml-0 w-fit mt-1 rounded-lg border-dark-brand-blue">
          <Gem color="#2da8d7" class="w-5 h-5 text-dark-brand-blue" />
          <span class="pl-3 bg-gradient-to-r from-[#2da8d7] to-[#467ddf] bg-clip-text text-transparent">{{ $t("Explore plans") }}</span>
        </button>
      </div>
    </div>

    <div class="bg-gradient-to-b from-[#2DA7D7]/25 h-36 w-[100%] absolute left-0 top-0 pointer-events-none" />
    <div class="absolute top-4 right-5">
      <div class="flex flex-col justify-center items-center">
        <span class="text-[#899399]">{{ $t("Forecasting Objects") }}</span>
        <div class="flex items-center">
          <span class="font-semibold">1</span>
          <span class="text-[#899399]">/1</span>
          <span class="font-semibold">{{ $t("Objects") }}</span>
        </div>
        {/*
        <div class="flex items-center hover:cursor-pointer z-30" @click="showLimits()">
          <Gem color="#2da8d7" class="border-none w-4 h-4 dark:text-gray-500" />
          <span class="pl-1 bg-gradient-to-r from-[#2da8d7] to-[#467ddf] bg-clip-text text-transparent">{{ $t("Need more?") }}</span>
        </div>
        */}
      </div>
    </div>
    <div class="text-3xl font-medium relative z-10 flex space-x-2">
      <Settings2 class="mr-2 w-10 h-10" color="#000000" /> {{ $t("Set Up Forecasting Object") }}
    </div>
    <div class="relative z-10 text-common-grey text-sm ml-12 -mt-2">
      {{ $t("Here you can add objects that you want to be able to forecast.") }}
    </div>
    <div class="flex flex-col h-full w-full mt-12">
      <div class="flex items-center w-full gap-4">
        <TextInput name="name"
                   type="text"
                   :label="$t('Name')"
                   classes=""
                   :placeholder="$t('Name')" />
        <SelectInput
          v-model="object_type"
          name="objects_type"
          :items="available_objects_to_use"
          label-attr="label"
          value-attr="id"
          :allow-null="false"
          :classes="'w-full'"
          :label="$t('Object Type')"
          :show-label="true"
          :is-box-background="true"
          input-classes="appearance-none text-left block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm" />
      </div>
      <div v-show="object_type" class="flex items-center w-full gap-4 mt-4">
        <SelectInput
          name="renewal_base_metric"
          :items="
            $store.state.metrics.filter(
              (x) => x.object_type == $utils.getObjectTypeById(object_type)?.type && (x.data_type == 'Date' || x.data_type == 'DateTime')
            )
          "
          :disabled="!object_type"
          label-attr="name"
          value-attr="id"
          :allow-null="false"
          :classes="'w-full'"
          :label="$t('Renewal Value')"
          :show-label="true"
          :is-box-background="true"
          input-classes="appearance-none text-left block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm" />
        <SelectInput
          name="renewal_date_metric"
          :items="
            $store.state.metrics.filter((x) => x.object_type == $utils.getObjectTypeById(object_type)?.type && x.data_type == 'Number')
          "
          :disabled="!object_type"
          label-attr="name"
          value-attr="id"
          :allow-null="false"
          :classes="'w-full'"
          :label="$t('Renewal Date')"
          :show-label="true"
          :is-box-background="true"
          input-classes="appearance-none text-left block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm" />
      </div>
      <div class="flex mt-8">
        <table>
          <tbody>
            <tr>
              <td>
                <span>{{ $t("Do you use ARR or MRR as your primary measurement?") }}</span>
              </td>
              <td>
                <div
                  class="w-full flex items-center gap-1 ml-2 flex-nowrap truncate justify-between border-[1px] border-[#B3CAD6] bg-[#F5F8FA] font-semibold text-[14px] rounded-full px-0.5 py-0.5">
                  <span
                    class="w-1/2 flex justify-center font-semibold text-[14px] rounded-full px-2 py-1 cursor-pointer"
                    :class="[
                      primary_measurement == 'arr'
                        ? 'text-white border-[1px] border-[#B3CAD6] bg-gradient-to-r from-[#2da8d7] to-[#467ddf]'
                        : ''
                    ]"
                    @click="primary_measurement = 'arr'">
                    {{ $t("ARR") }}
                  </span>
                  <span
                    class="w-1/2 flex justify-center font-semibold text-[14px] rounded-full px-2 py-1 cursor-pointer"
                    :class="[
                      primary_measurement == 'mrr'
                        ? 'text-white border-[1px] border-[#B3CAD6] bg-gradient-to-r from-[#2da8d7] to-[#467ddf]'
                        : ''
                    ]"
                    @click="primary_measurement = 'mrr'">
                    {{ $t("MRR") }}
                  </span>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <span>{{ $t("How is your target measured?") }}</span>
              </td>
              <td>
                <div
                  class="w-full flex items-center gap-1 ml-2 flex-nowrap truncate justify-between border-[1px] border-[#B3CAD6] bg-[#F5F8FA] font-semibold text-[14px] rounded-full px-0.5 py-0.5">
                  <span
                    class="w-1/2 flex justify-center font-semibold text-[14px] rounded-full px-2 py-1 cursor-pointer"
                    :class="[
                      target_measured == 'monthly'
                        ? 'text-white border-[1px] border-[#B3CAD6] bg-gradient-to-r from-[#2da8d7] to-[#467ddf]'
                        : ''
                    ]"
                    @click="target_measured = 'monthly'">
                    {{ $t("Monthly") }}
                  </span>
                  <span
                    class="w-1/2 flex justify-center font-semibold text-[14px] rounded-full px-2 py-1 cursor-pointer"
                    :class="[
                      target_measured == 'quarterly'
                        ? 'text-white border-[1px] border-[#B3CAD6] bg-gradient-to-r from-[#2da8d7] to-[#467ddf]'
                        : ''
                    ]"
                    @click="target_measured = 'quarterly'">
                    {{ $t("Quarterly") }}
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="flex justify-between w-full mt-16 space-x-2 items-center">
      <div class="cursor-pointer text-light-brand-blue" @click="$emit('cancel')">
        {{ $t("Cancel") }}
      </div>
      <div class="cursor-pointer z-30" @click="$emit('done')">
        <div
          class="flex items-center border-transparent bg-gradient-to-r from-[#2DA7D7] to-[#841FF4] px-6 font-bold text-white rounded-full w-fit-content h-[50px] content-center text-[14px]">
          <span>{{ $t("Save Forecasting Preference") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectInput from "@/components/shared/SelectInput.vue"
// eslint-disable-next-line vue/no-unused-components
import { Gem, Settings2 } from "lucide-vue-next"
import TextInput from "@/components/shared/TextInput.vue"

export default {
  components: {
    Gem,
    TextInput,
    SelectInput,
    Settings2
  },

  inject: ["setPageLayout", "updateLayouts"],
  props: {
    classes: {
      type: String,
      default: ""
    }
  },

  emits: ["update:currentItems", "search", "cancel", "done"],
  data() {
    return {
      is_blue_bg: false,
      object_type: null,
      primary_measurement: "arr",
      target_measured: "monthly"
    }
  },
  computed: {
    available_objects_to_use() {
      return this.$store.state.object_types
    }
  },

  watch: {},

  methods: {
    showLimits() {}
  }
}
</script>
<style scoped>
.ghost {
  @apply opacity-50 bg-white border-0;
}
.chosen {
  @apply opacity-50 bg-white border-0;
}
.flip-list {
  transition: all 0.25s ease-out;
}
</style>
